import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Avatar1 from 'Components/ComponentLibrary/Components/Avatars/Avatar1';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
  },
  img: {
    width: '50%',
    height: '50%',
  },
});

const IconAvatar = ({
  className,
  classes,
  src,
}) => {
  return (
    <Avatar1
      className={classNames(classes.root, className)}
    >
      <img
        className={classes.img}
        src={src}
        alt={'icon'}
      />
    </Avatar1>
  );
};

IconAvatar.defaultProps = {
  className: '',
};

IconAvatar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  src: PropTypes.string.isRequired,
};

export default withStyles(styles)(IconAvatar);
